import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Modal, Row } from 'react-bootstrap'
import { ImCross } from 'react-icons/im'
import Select from 'react-select'
import { WebApiCalls } from '../../../webApiCalls/WebApiCalls'
import { toast } from 'react-toastify'
import { useAuth } from '../../../hooks/useAuth'
const VendorEditModal = (props) => {
    const {getToken}=useAuth();
    const { data, show, handleClose, routes, getAllVendors, offset } = props
    const [id, setId] = useState()
    const [name, setName] = useState('')
    const [phone_no, setPhone_no] = useState('')
    const [location, setLocation] = useState()
    const [status, setStatus] = useState()
    const [selectedRoute, setSelectedRoute] = useState({})

    useEffect(() => {
        setId(data?._id)
        setName(data?.name)
        setPhone_no(data?.phone_no)
        setLocation(data?.location)
        setStatus(data?.status)
        setSelectedRoute(s => {
            const obj = { value: data?.route?._id, label: data?.route?.name }
            return obj
        })
    }, [data])

    const handleSubmit = async (e) => {
        e.preventDefault()
        const token = getToken();
        if (token && id) {
            const obj = {
                name,
                phone_no,
                status,
                location,
                route: selectedRoute.value,
            }
            new WebApiCalls().udpateVendor(token, obj, id)
                .then(res => {
                    if (res && res?.code == 200) {
                        toast.success(res?.desc)
                        handleClose()
                        getAllVendors(offset)
                    }
                })
                .catch(err => { })
        }
    }

    return (
        <Modal
            size="lg"
            show={show}
            onHide={(e) => handleClose(e)}
            aria-labelledby="example-modal-sizes-title-lg"
            centered
        >
            <Form>
                <Modal.Header className='px-0'>
                    <Modal.Title className='modal-title px-4' id="example-modal-sizes-title-lg">
                        Edit Vendor Details
                    </Modal.Title>
                    <button className="modal-close-btn me-4 text-center" onClick={e => {
                        e.preventDefault()
                        handleClose()

                    }}>
                        <ImCross color='#fff' size={12} />
                    </button>
                </Modal.Header>
                <Modal.Body className='px-4 justify-content-center'>
                    <Row className="mx-2">
                        <Col md={6} className="mb-4">
                            <div className='modal-small-heading'>Name</div>
                            <div className='mt-2'>
                                <input className="edit-modal-input" type="text"
                                    value={name} onChange={e => setName(e.target.value)}
                                    placeholder="Name here" required />
                            </div>
                        </Col>

                        <Col md={6} className="mb-4">
                            <div className='modal-small-heading'>Location</div>
                            <div className='mt-2'>
                                <div className='mt-2'>
                                    <input className="edit-modal-input" type="text"
                                        value={location} onChange={e => setLocation(e.target.value)}
                                        placeholder="Location here" required />
                                </div>
                            </div>
                        </Col>

                        <Col md={6} className="mb-4">
                            <div className='modal-small-heading'>Phone</div>
                            <div className='mt-2'>
                                <input className="edit-modal-input" 
                                type="text"
                                value={phone_no} 
                                onChange={e => setPhone_no(e.target.value)}
                                placeholder="+2323232323" 
                                pattern='^\+\d{7,10}$'
                                required />
                            </div>
                        </Col>

                        <Col md={6} className="mb-4">
                            <div className='modal-small-heading'>Status</div>
                            <div className="mt-2">
                                <select className='gender-selector' value={status} onChange={e => setStatus(e.target.value)}>
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                </select>
                            </div>
                        </Col>

                        <Col md={6} className="mb-4">
                            <div className='modal-small-heading'>Route</div>
                            <div className='mt-2 single-selector'>
                                <Select options={routes} value={selectedRoute}
                                    onChange={(e) => {
                                        setSelectedRoute(e)
                                    }} />
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className='d-flex justify-content-center'>
                    <Button type="submit" className='default-btn save-btn' onClick={(e) => { handleSubmit(e) }}>SAVE</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    )
}

export default VendorEditModal